import { Typography } from '@material-ui/core';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { convertPricePerKmToPricePerMile } from 'shared/modules/loadboard/LoadboardUtils';

interface Props {
  pricePerKm: number | null;
}

export function PostingPricePerMile({ pricePerKm }: Props) {
  return pricePerKm == null ? null : (
    <Typography
      display="inline"
      color="textSecondary"
      aria-label="Price per mile"
    >
      {formatCurrency(convertPricePerKmToPricePerMile(pricePerKm), {
        minimumFractionDigits: 2,
      })}
      /mi
    </Typography>
  );
}
